// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'

// svg
import { ArrowRight } from '/react4xp/components/Icons/Ux'

// types
interface TransportCardsProps {
    className?: string
    isAnimated?: boolean
    title?: string
    intro?: string
    cards?: {
        color?: 'green-light' | 'beige'
        title?: string
        intro?: string
        href?: {
            href?: string
            external?: boolean
        }
    }[]
}

// css
import './index.scss'

export default function TransportCards({
    className,
    isAnimated,
    title,
    intro,
    cards
}: TransportCardsProps) {
    return (
        <Section className={clsx(
            'transport-cards-component',
            className
        )}>
            <div className='container'>

                {title && (
                    <h2 className='h2'>
                        {title}
                    </h2>
                )}

                {intro && (
                    <div
                        className='body transport-cards-component__intro'
                        dangerouslySetInnerHTML={{
                            __html: intro
                        }}
                    />
                )}

                {cards && (
                    <div
                        className={clsx(
                            'transport-cards-component__cards',
                            cards?.length === 1 && 'transport-cards-component__cards--1',
                            cards?.length === 2 && 'transport-cards-component__cards--2',
                            cards?.length >= 3 && 'transport-cards-component__cards--3'
                        )}
                        data-stagger-scale={isAnimated ? 'true' : 'false'}
                    >
                        {cards?.map((item, i) => (
                            <a
                                className={clsx(
                                    'transport-cards-component__card',
                                    item.color === 'green-light' && 'bg-green-light',
                                    item.color === 'beige' && 'bg-beige'
                                )}
                                href={item.href?.href}
                                target={item.href?.external ? '_blank' : undefined}
                                rel={item.href?.external ? 'noopener noreferrer' : undefined}
                                key={i}
                            >

                                {item.title && (
                                    <span className='h3'>
                                        {item.title}
                                    </span>
                                )}

                                {item.intro && (
                                    <span
                                        className='body'
                                        dangerouslySetInnerHTML={{
                                            __html: item.intro
                                        }}
                                    />
                                )}

                                <ArrowRight />

                            </a>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}